"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatIssueUrl = formatIssueUrl;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const ContentSantizer_1 = require("./ContentSantizer");
// Remove this when https://github.com/typescript-eslint/typescript-eslint/issues/2728 is done
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const packageJson = require('../../package.json');
const issuesUrl = `https://github.com/dotnet/vscode-dotnet-runtime/issues/new/choose`;
function formatIssueUrl(error, context) {
    context.logger.dispose(); // Ensure log file is up to date
    const errorMessage = !error ? '' : `**Error Message:** ${(0, ContentSantizer_1.sanitize)(error.message)}
**Error Stack:** ${error.stack === undefined ? '' : (0, ContentSantizer_1.sanitize)(error.stack)}`;
    const issueBody = `<!-- IMPORTANT: Please be sure to remove any private information before submitting. -->

Please attach the log file located at ${context.logger.getFileLocation()}. Note that this file may contain personal data.

**Extension Version:** ${packageJson === null || packageJson === void 0 ? void 0 : packageJson.version}
${errorMessage}`;
    return [issuesUrl, issueBody];
}
//# sourceMappingURL=IssueReporter.js.map